module.exports = __webpack_public_path__ + "img/ycc_earncoyns.fd7cb231.png";